import nodeClient from "./node-client";

export const searchCategories = async (query = "") => {
  const response = await nodeClient.get(`/service/private/v0/list/last/category`);
  return response?.data;
};

export const getCategory = async () => {
  const response = await nodeClient.get(`/service/private/v0/list/category`);
  return response?.data?.result?.rows;
} 
